import { AssetClass } from "types/AssetClass";
import { YieldHistory } from "types/YieldHistory";
import { createCustomAction } from "typesafe-actions";

const YIELDHISTORY_DATA_LOAD = "YIELDHISTORY/YIELDHISTORY_DATA_LOAD";
const YIELDHISTORY_DATA_LOAD_SUCCESS = "YIELDHISTORY/YIELDHISTORY_DATA_LOAD_SUCCESS";
const YIELDHISTORY_DATA_LOAD_FAIL = "YIELDHISTORY/YIELDHISTORY_DATA_LOAD_FAIL";

export type YieldHistoryContentType = "all" | keyof typeof AssetClass;

export const load = createCustomAction(
  YIELDHISTORY_DATA_LOAD,
  (type) => (contentType: YieldHistoryContentType) => ({
    type,
    contentType,
  })
);

export const loadSuccess = createCustomAction(
  YIELDHISTORY_DATA_LOAD_SUCCESS,
  (type) => (contentType: YieldHistoryContentType, data?: YieldHistory[]) => ({
    type,
    contentType,
    data,
  })
);

export const loadFail = createCustomAction(
  YIELDHISTORY_DATA_LOAD_FAIL,
  (type) => (contentType: YieldHistoryContentType, error?: string) => ({
    type,
    contentType,
    error,
  })
);
